import cx from 'classnames';
import moment from 'moment';

import { useTimeInputScroll } from './useTimeInputScroll';
import { isTimeValueDisabled } from '../utils';

export enum TimeValueType {
  HOUR = 'hour',
  MINUTE = 'minute',
}

interface TimePickerInputProps {
  values: number[];
  selectedDate: Date | undefined | null;
  handleChange: (value: number) => void;
  valueType: TimeValueType;
  disabledBeforeTime?: Date;
}

const TimePickerInput = ({
  selectedDate,
  values,
  handleChange,
  valueType,
  disabledBeforeTime,
}: TimePickerInputProps) => {
  const { scrollContainerRef, attachTimeValueRef } = useTimeInputScroll({
    values,
    selectedDate,
    valueType,
    disabledBeforeTime,
  });

  const selectedHour = selectedDate ? moment(selectedDate).hour() : undefined;
  const selectedMinute = selectedDate ? moment(selectedDate).minute() : undefined;
  const isHourInput = valueType === TimeValueType.HOUR;
  const parsedValue = isHourInput ? selectedHour : selectedMinute;

  return (
    <div className="flex flex-col items-center">
      {!!valueType && <span className="font-semibold text-gray-500 mb-2">{isHourInput ? 'HH' : 'MM'}</span>}
      <div className="h-48 overflow-y-scroll no-scrollbar space-y-1" ref={scrollContainerRef}>
        {values.map((value, idx) => {
          const isDisabled = isTimeValueDisabled({ value, valueType, disabledBeforeTime, selectedHour });

          return (
            <div
              key={value}
              ref={attachTimeValueRef(idx)}
              onClick={() => !isDisabled && handleChange(value)}
              className={cx(
                'px-2 w-14 h-8 rounded-xl flex items-center justify-center font-light text-sm',
                parsedValue === value ? 'text-white bg-primary-50' : 'text-gray-700',
                isDisabled ? 'opacity-50 cursor-not-allowed text-gray-400' : 'cursor-pointer'
              )}
            >
              {value.toString().padStart(2, '0')}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimePickerInput;
